import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { removeTagFilter } from '../../../../actions/actions'

export default function TagsFilters () {
  const tagFilters = useSelector(({ certFilters }) => certFilters.tags, shallowEqual)
  const dispatch = useDispatch()

  const onRemoveTagClick = (tagId) => {
    dispatch(removeTagFilter(tagId))
  }
  return (
    <div className='col-md-2'>
      {tagFilters.map((item, i) => {
        return (
          <span key={i} className='badge badge-pill badge-light' style={{ cursor: 'pointer' }} onClick={(e) => onRemoveTagClick(item.id)}>{item.name}
            <i key={i} className='mdi mdi-cancel' />
          </span>
        )
      })}
    </div>
  )
}
